import Cookies from 'js-cookie';

import {
  BY_HELP_AUTH,
  BY_HELP_EMAIL,
  DEV_BY_HELP_AUTH,
  DEV_BY_HELP_EMAIL,
  PROD_MODE,
} from '@app/constants';
import type { NAuth } from '@app/types';
import {
  defineDeployingMode,
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from '@app/utils';

const EMAIL_COOKIE_EXPIRES_DAYS = 182;
const AUTH_COOKIE_EXPIRES_DAYS = 364;

export const getAuthorizationCookieNames = () => {
  const isProdMode = defineDeployingMode(window.location.host) === PROD_MODE;

  return {
    authCookieName: isProdMode ? BY_HELP_AUTH : DEV_BY_HELP_AUTH,
    emailCookieName: isProdMode ? BY_HELP_EMAIL : DEV_BY_HELP_EMAIL,
  };
};

export const getAuthorizationAccessToken = () => getAccessToken();

export const clearAuthorizationAccessToken = () => {
  removeAccessToken();
};

export const persistAuthorizationAccessToken = (accessToken: string | null) => {
  if (!accessToken) {
    return;
  }

  setAccessToken(accessToken);
};

export const persistAuthorizationCookies = ({
  CookieData,
  CookieEmail,
}: Pick<NAuth.ModelAuthentication, 'CookieData' | 'CookieEmail'>) => {
  const { authCookieName, emailCookieName } = getAuthorizationCookieNames();

  Cookies.remove(authCookieName);
  Cookies.remove(emailCookieName);

  if (CookieData) {
    Cookies.set(authCookieName, CookieData, {
      expires: AUTH_COOKIE_EXPIRES_DAYS,
    });
  }

  if (CookieEmail) {
    Cookies.set(emailCookieName, CookieEmail, {
      expires: EMAIL_COOKIE_EXPIRES_DAYS,
    });
  }
};
